<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.userName">
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserInfo.userName }}</p>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img
          v-if="activeUserInfo.userName"
          src="https://regnaparts.s3-sa-east-1.amazonaws.com/images/default-user-male.png"
          key="onlineImg"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
      </div>
      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/perfil').catch (err => {})"
          >
            <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Perfil</span>
          </li>

          <li
            v-if="getGroup =='admin'"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/user/user-list').catch (err => {})"
          >
            <feather-icon icon="UsersIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Usuários</span>
          </li>
          <!--
          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="CheckSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Tasks</span>
          </li>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="MessageSquareIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Chat</span>
          </li>

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
            <feather-icon icon="HeartIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Wish List</span>
          </li>-->

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import { userKey, avatarPhoto } from "@/global";
export default {
  data() {
    return {};
  },

  computed: {
    activeUserInfo() {
      let userInfoLocalStorage = JSON.parse(localStorage.getItem(userKey));
      let user = this.$store.state.user || userInfoLocalStorage;
      return user;
    },
    getGroup() {
      let userInfoLocalStorage = JSON.parse(localStorage.getItem(userKey));
      let userGroup = this.$store.state.user.userGroup || userInfoLocalStorage.userGroup;
      return userGroup;
    }
  },
  methods: {
    async logout() {
      localStorage.removeItem(userKey);
      //this.$store.commit("SET_USER_INFO", null);

      this.$router.push({ name: "login" });
    }
  }
};
</script>
